import React from 'react';
import { Icon } from '@unite-us/ui';
export default function StepHeader(props) {
  var header = props.header,
    icon = props.icon,
    children = props.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center responsive-max-width flex-col mx-auto"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-3xl my-5 text-center font-bold"
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    icon: "V2Referrall",
    color: "#182a44",
    className: "w-12 h-12 pr-4"
  }), header), /*#__PURE__*/React.createElement("div", {
    className: "grid place-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-1/2 text-center"
  }, children))));
}
//# sourceMappingURL=StepHeader.js.map